// @flow

export { DisplayBankTransferBrand } from './display-bank-transfer-brand';
export { DisplayBankTransferBrandAfrica } from './display-bank-transfer-brand-africa';
